import React, { Component } from 'react';
import { Tabs } from 'antd';
import './tabs.scss';
import dict from '../../dictionary';
import trans from '../../translations.json';
const { TabPane } = Tabs;

const TabsGroup = (props) => (
  <Tabs
    size="small"
    activeKey={props.selection}
    type="card"
    onChange={props.onTabChange}
  >
    <TabPane
      tab={trans.viewModes.tabs.daily[props.lang]}
      key={props.tabs.newCases}
    />
    <TabPane
      tab={trans.viewModes.tabs.cumulative[props.lang]}
      key={props.tabs.totalCases}
    />
  </Tabs>
);

class TabsMode extends Component {
  state = {
    selectedTab: this.props.default || dict.tabs.newCases,
  };

  onTabChange = (tabName) => {
    this.setState({
      selectedTab: tabName,
    });
  };

  render() {
    const CompToRender = () => this.props[this.state.selectedTab];

    return (
      <>
        <TabsGroup
          selection={this.state.selectedTab}
          onTabChange={this.onTabChange}
          tabs={dict.tabs}
          lang={this.props.lang}
        />
        <CompToRender />
      </>
    );
  }
}
export default TabsMode;
